function formatCurrency(amount: number | string = 0): string {
  const formattedCurrency: string = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(Number(amount));
  return formattedCurrency;
}
export { formatCurrency };
